import { Component, Input, OnInit } from '@angular/core';
import {Location} from '@angular/common';

import { File } from 'app/models/file';
import {GoogleTagManagerService} from '../../../services/google-tag-manager.service';

@Component({
  selector: 'app-viewer-header',
  templateUrl: './viewer-header.component.html',
  styleUrls: ['./viewer-header.component.scss']
})
export class ViewerHeaderComponent implements OnInit {
  @Input() title: string;
  @Input() type: string;
  @Input() file: File;
  @Input() hideOptions: boolean;
  constructor(
    private _location: Location,
    private gtmService: GoogleTagManagerService,
  ) {}

  backClicked() {
    if (typeof this.type !== 'undefined') {
      this.gtmService.pushEvent(`${this.type} - Close panel`);
    }
    this._location.back();
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/shared/components/viewer-header/viewer-header.component.ts